import { LocalDate } from '../../core/model/local-date';
import { ModelBase } from '../../core/model/model-base';
import { Money } from '../../core/model/money';
import { Currencies } from '../../core/pipe/currency.pipe';
import { MeterMediaType } from './const/enums';
import { PriceListItem } from './priceListItem';
import {
  ColdWaterPaymentKind,
  HeatingPaymentKind,
  HotWaterPaymentKind,
  HouseholdElectricityPaymentKind,
  ParkingElectricityPaymentKind,
} from '../../rent/model/const/enums';

export class PriceList extends ModelBase {
  constructor() {
    super();
  }

  articleId: string;
  articleCodeCaption: string;
  meterTypeCaption: string;
  meterType: MeterMediaType;
  name: string;
  currencyCode: string;
  prices: PriceListItem[];
  latestPrice: Money;
  todayPrice: Money;
}

export interface ImdPriceListProperty {
  id: string;
  name: string;
}

export interface ImdPriceListRentalObject {
  id: string;
  rentalId: string;
  street: string;
  rentalObjectType: string;
  electricityMeterName: string;
  chargingElectricityMeterName: string;
  hotWaterMeterName: string;
  coldWaterMeterName: string;
  heatingMeterName: string;
  householdElectricityPayment: HouseholdElectricityPaymentKind | null;
  parkingChargingElectricityPayment: ParkingElectricityPaymentKind | null;
  heatingPayment: HeatingPaymentKind | null;
  coldWaterPayment: ColdWaterPaymentKind | null;
  hotWaterPayment: HotWaterPaymentKind | null;
  householdElectricityPaymentCaption?: string;
  parkingChargingElectricityPaymentCaption?: string;
  heatingPaymentCaption?: string;
  coldWaterPaymentCaption?: string;
  hotWaterPaymentCaption?: string;
}
